/**
 * Language switch for the portal header (en / fr / it / da). The choice is
 * applied and saved to the account by the LocaleProvider.
 */

import { Check, Languages } from 'lucide-react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslation } from 'react-i18next';
import { LOCALE_LABELS } from '@nord-living/shared';

import { Button } from '@/components/ui';
import { useLocale } from '@/providers/LocaleProvider';

const ITEM =
  'flex cursor-pointer select-none items-center justify-between gap-3 rounded-lg px-2.5 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent';

export function PortalLanguageMenu() {
  const { t } = useTranslation('portal');
  const { locale, setLocale, supportedLocales } = useLocale();
  const label = t('layout.languageMenu', { language: LOCALE_LABELS[locale] });
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button variant="ghost" size="sm" aria-label={label} title={label}>
          <Languages aria-hidden />
          <span className="uppercase">{locale}</span>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="end" sideOffset={8} className="z-50 min-w-[180px] rounded-xl border bg-popover p-1.5 text-popover-foreground shadow-lg">
          {supportedLocales.map((code) => (
            <DropdownMenu.Item key={code} className={ITEM} onSelect={() => setLocale(code)}>
              {LOCALE_LABELS[code]}
              {code === locale ? <Check className="h-4 w-4 text-primary" aria-hidden /> : null}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
